'use client'
import React, { useEffect, useRef } from 'react'

import { SignInPopupRef, SignInPopup } from './SignInPopup'
import { appSelectors, useAppStore } from '@/store'

export const SignInPopupWrapper: React.FC = () => {
  const popupRef = useRef<SignInPopupRef>(null)
  const { isSignUpVisible } = useAppStore(appSelectors.status)
  const user = useAppStore(appSelectors.user)

  useEffect(() => {
    if (isSignUpVisible && popupRef.current && !user?.accessToken) {
      popupRef.current?.open()
    }
  }, [isSignUpVisible, user])

  return <SignInPopup ref={popupRef} />
}
